import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getRequestTypeTitle } from "helpers/RequestHelper";
import NoTableData from "components/NoTableData";

const LabResultRow = ({ tableRows }) => {
  if (tableRows.length) {
    return tableRows.map(row => {
      const {
        id,
        name,
        display,
        modelnumber,
        requesttypeid,
        testingstatus,
        formatedtransactionnumber
      } = row;

      const tn = formatedtransactionnumber;

      return (
        <tr key={id}>
          <td>
            <Link to={`/lab/results/${id}`}>{tn}</Link>
          </td>
          <td>{name}</td>
          <td>{modelnumber}</td>
          <td>{display}</td>
          <td>{getRequestTypeTitle(requesttypeid)}</td>
          <td>{testingstatus}</td>
        </tr>
      );
    });
  }

  return <NoTableData />;
};

LabResultRow.propTypes = {
  tableRows: PropTypes.array.isRequired
};

export default LabResultRow;



// WEBPACK FOOTER //
// ./src/components/labRequest/LabResultRow.js